<template>
    <q-layout data-testid="report-manager" class="q-pa-lg">
      <q-card class="fit">
        <q-card-section class="q-py-xs">
          <div class="report-title">
            {{reportTitle || name}}
          </div>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <JtDynamicForm
              data-testid="form"
              ref="form"
              :inputs="form.inputs"
              :model="form.dadosForm"
              :relacionamentos="form.relacionamentos"
              :interface="form.nmInterface"
              @on-select-change="onSelectChangeHandler"
            />
          </div>
        </q-card-section>
      </q-card>
      <div class="row full-width q-col-gutter-lg justify-center q-py-md">
            <div class="col-lg-2 col-md-3">
                <q-btn class="full-width" color="grey-7" @click="onClear">
                    {{ $gettext('CLEAN') }}
                </q-btn>
            </div>
            <div class="col-lg-2 col-md-3">
                <q-btn class="full-width" color="info" @click="onGenerateReportClick">
                {{ $gettext('GENERATE') }}
                </q-btn>
            </div>
        </div>
      <JtDocsViewer
        :src="fileSrc"
        :title="reportTitle || name"
        :pdf="reportFormat.pdf"
        :xls="reportFormat.xls"
        ref="reportModal"
      />
    </q-layout>
  </template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { JtDocsViewer } from 'jtech-webcomps/src/components/jtech-docs'
import { JtDynamicForm } from 'jtech-webcomps'
import { repository } from 'jtech'

@Component({
  name: 'WasteRecoveryReceiptReport',
  components: {
    JtDynamicForm,
    JtDocsViewer
  },
  props: {
    forms: { type: Array, required: true }
  }
})
class WasteRecoveryReceiptReport extends Vue {
  fileSrc = null
  reportTitle = 'Recebimento Resíduo Valorização'
    dadosTelaFromRepository = []
    reportGenerationFormat = {
      online: true,
      scheduling: false
    }

    reportFormat = {
      pdf: false,
      xls: true
    }

    onClear () {
      this.$refs.form.resetForm()
    }

    __getDisplayData () {
      return repository.resolve('wasteRecoveryReceiptReport.wasteRecoveryReceiptReport')
    }

    async beforeMount () {
      this.dadosTelaFromRepository = await this.__getDisplayData()
    }

    get form () {
      return this.dadosTelaFromRepository[0]
    }

    emitCloseToBus () {
      this.$emit('on-close', {})
    }

    get computedDadosTelaFromRepository () {
      return Array.isArray(this.dadosTelaFromRepository) &&
      this.dadosTelaFromRepository.length
        ? this.dadosTelaFromRepository[0]
        : {}
    }

    async __whenGenerationFormatIsOnline ({ nmArquivo }) {
      try {
        const result = await this.$jt.repository.downloadFile(
          nmArquivo,
          'xls',
          '',
          'application/xls'
        )
        this.fileSrc = URL.createObjectURL(result)
        this.$nextTick(() => {
          if (this.reportFormat.xls) {
            this.__downloadFile(this.fileSrc, this.reportTitle, '.xls')
            this.emitCloseToBus()
          } else {
            this.$refs.reportModal.show()
          }
        })
        return Promise.resolve()
      } catch (error) {
        return Promise.reject(error)
      }
    }

    __downloadFile (fileSrc, fileName = 'downloaded_file', extension = '.xls') {
      const link = document.createElement('a')
      link.style = 'display: none'
      link.download = `${fileName}${extension}`
      link.href = fileSrc
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }

    async onGenerateReportClick () {
      try {
        this.$emit('generate', {
          dadosForm: this.computedDadosTelaFromRepository.dadosForm,
          nmInterface: this.computedDadosTelaFromRepository.nmInterface
        })
        const resolveLogicResult = await this.$jt.repository.resolveLogic(
          this.computedDadosTelaFromRepository.nmInterface,
          this.computedDadosTelaFromRepository.dadosForm
        )

        await this.__whenGenerationFormatIsOnline(resolveLogicResult)
      } catch (error) {
        console.error(error)
      }
    }
}

export default WasteRecoveryReceiptReport
</script>

<style>
.report-title {
  font-weight: 500;
  font-size: 1.3em;
  margin-top: 5px;
  border-bottom: 1px solid #e0e0e0;
}
.btn-container {
  margin-top: 30px;
}
</style>
